<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-button variant="secondary" class="ml-2" @click="$router.push('/pagos')">
        <i class="fas fa-arrow-left"></i> {{$t('volver')}}
      </b-button>

      <b-card-header class="border-0">
        <h3 class="mb-0">{{ $t('estado') }} : {{ pago.nombre }}</h3>
      </b-card-header>

      <b-form @submit.prevent="submitForm">
        <div class="d-flex justify-content-end">
          <b-button @click="cancelBtn()" :variant="!isEditMode ? 'info' : 'danger'">
            {{ !isEditMode ? $t('editar') : $t('cancelar') }}
          </b-button>

          <b-button v-if="isEditMode" :disabled="!isEditMode" type="submit" variant="primary" class="ml-2">
            {{ $t('actualizar') }} 
          </b-button>
        </div>
        <b-row class="card-ing">
          <b-col md="3">
            <b-form-group label-for="Nombre">
              <template v-slot:label>
                {{ $t('nombre') }} <span v-if="isEditMode" class="text-danger">*</span>
              </template>
              <b-form-input id="nombre" :disabled="!isEditMode" v-model="pago.nombre" required
                :placeholder="$t('ingrese_nombre')"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label="Fecha" label-for="fecha">
              <template v-slot:label>
                {{ $t('fecha') }}  <span v-if="isEditMode" class="text-danger">*</span>
              </template>
              <b-form-input id="fecha" type="date" :disabled="!isEditMode" v-model="pago.fecha" required></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label-for="file-input">
              <template v-slot:label>
                {{ $t('documento') }}
              </template>
              <b-row>
                <b-col v-if="pago.url" md="8" class="d-flex align-items-start">
                  <FileViewer :id="pago.id" :url="pago.url" />
                  <b-button v-if="isEditMode" @click="pago.url = null" variant="danger" class="ml-2">
                    {{ $t('eliminar_documento') }}
                  </b-button>
                </b-col>
                <b-col v-else md="8" class="d-flex align-items-start">
                  <b-form-file class="adjunto" id="file-input" :disabled="!isEditMode" v-model="file" :browse-text="$t('adjuntar')"
                    :state="file ? true : null" accept=".jpg, .jpeg, .png, .pdf, .doc, .docx, .bmp"
                    :placeholder="$t('selecciona_archivo')">
                  </b-form-file>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>

        </b-row>
      </b-form>
    </base-header>
  </div>
</template>
<script>
import pagoService from '@/api/pagoService';
import UserTable from '@/views/Usuario/UsersTable.vue';
import MaterialTable from "@/views/Material/MaterialTable.vue";
import FileViewer from '@/components/FileViewer';
export default {
  components: {
    UserTable,
    MaterialTable,
    FileViewer
  },
  data() {
    return {
      isEditMode: false,
      pago: {},
      pagoAux: {},
      file: null
    };
  },
  async beforeMount() {
    const id = this.$route.params.id;
    this.pago = await pagoService.get(id);
    this.pagoAux = JSON.parse(JSON.stringify(this.pago));

  },
  methods: {
    async cancelBtn() {      
    const id = this.$route.params.id;
      if(this.isEditMode)
        this.pago = await pagoService.get(id);
      this.isEditMode = !this.isEditMode;
    },
    isPdf(url) {
      return url.toLowerCase().endsWith('.pdf');
    },
    isImage(url) {
      return /\.(jpg|jpeg|png|gif|bmp|svg)$/i.test(url);
    },
    async submitForm() {
      Swal.fire({
        title: this.$t('estas_seguro'),
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t('aceptar'),
        denyButtonText: this.$t('cancelar'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            Swal.fire({
              html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">${this.$t('guardando')}</h3>
                        </div>
                    </div>`,
              showConfirmButton: false,
              allowOutsideClick: false
            });

            const response = await pagoService.update(this.pago, this.pago.id, this.file);
            if (!response) throw new Error(this.$t('error_guardar'));
            this.pago = await pagoService.get(this.pago.id);
            this.pagoAux = JSON.parse(JSON.stringify(this.pago));
            this.isEditMode = false;
            this.file = null;
            Swal.fire({
              title: this.$t('cambios_guardados'),
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              background: '#f8f9fa',
              customClass: {
                title: 'swal-title',
                icon: 'swal-icon',
              },
            });
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: this.$t('error_2')
            });
          }
        } else if (result.isDenied) {
          Swal.close();
        }
      });
    }


  },
};
</script>
<style>
.el-table.table-dark {
  background-color: #4d4c4c;
  color: #f8f9fe;
}

.el-table.table-dark th,
.el-table.table-dark tr {
  background-color: #4d4c4c;
}

.el-table.table-dark td,
.el-table.table-dark th.is-leaf {
  border-bottom: none;
}
.adjunto input{
  width: initial;
}
.adjunto{
  width: fit-content;
}
</style>
